import gql from "graphql-tag";

export const QueryCompanyEnabledProducts = gql`
  query GetCompanyEnabledProducts(
    $list: CompaniesList!
    $filter: CompaniesFilter!
  ) {
    companies(list: $list, filter: $filter) {
      metaData {
        count
      }
      objects {
        id
        name
        enabledProducts
        account {
          id
          name
        }
      }
    }
  }
`;
